<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("edit") }} {{ $tc("rawmaterials", 2) }}
      </div>
      <router-link class="btn-blue" to="/fnb/raw-materials"
        >{{ $tc("rawmaterials", 2) }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <form class="row" style="zoom: 0.9">
        <div class="col-lg-6 col-xl-3 align-self-center mb-3">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="rm_name"
                name="rawmaterial"
                id="rawmaterial"
                v-validate="'required|max:200'"
              />
              <label>{{ $tc("rawmaterials", 2) }}</label>
            </div>
            <!-- <Tooltip :title="$t('rawmaterial_tooltip')" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('rawmaterial')">{{
              errors.first("rawmaterial")
            }}</span>
          </p>
        </div>
        <div class="col-lg-6 col-xl-3 align-self-center mb-3">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="alt_rm_name"
                name="alt_rm_name"
                id="alt_rm_name"
                v-validate="'max:200'"
              />
              <label>{{ "Alternate Name" }}</label>
            </div>
            <!-- <Tooltip :title="$t('rawmaterial_tooltip')" /> -->
          </div>
          <p class="error_message">
              <span v-if="submitted && errors.has('alt_rm_name')">{{
                errors.first("alt_rm_name")
              }}</span>
            </p>
        </div>

        <div class="col-lg-6 col-xl-3 align-self-center mb-3">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                disabled
                placeholder="."
                type="text"
                v-model="rm_code"
                name="code"
                id="code"
              />
              <label>{{ $t("code") }}</label>
            </div>
            <!-- <Tooltip :title="$t('rawmaterial_Code')" /> -->
          </div>
          <!-- <p v-if="submitted && errors.has('code')" class="error_message">{{ errors.first('code') }}</p> -->
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-3 align-self-center mb-3">
          <div class="dropdown-curve-container pr-28px">
            <label :class="rmc_label.length > 0 ? 'shift-up' : ''"
              >{{ $tc("rawmaterials", 1) }} {{ $tc("category", 1) }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :text="rmc_label"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Raw Material"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchRawMaterial()"
                    v-on:keydown="onSearchRawMaterial()"
                    v-on:search="onSearchRawMaterial()"
                    v-model="searchRawMaterial"
                  />
                </div>
                <b-dropdown-item
                  v-for="(rmc, rmcIndex) in raw_material_categories"
                  :key="rmcIndex"
                  href="#"
                  @click="
                    rmc_id = rmc.rmc_id;
                    rmc_label = rmc.rmc_category;
                    searchRawMaterial = '';
                    onSearchRawMaterial();
                  "
                  >{{ rmc.rmc_category }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
            <p class="error_message">
              <span v-if="submitted && rmc_label == ''"
                >Please Select Raw Material Category.</span
              >
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-3 align-self-center mb-3">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="stock_alert_quantity_threshold"
                name="quantity"
                id="quantity"
                v-validate="'required|numeric|max_value:999999'"
              />
              <label>{{ $t("minimumstocklevel") }}</label>
            </div>
            <!-- <Tooltip :title="$t('quantityalert_tooltip')" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('quantity')">{{
              errors.first("quantity")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-3 align-self-center mb-3">
          <div class="dropdown-curve-container">
            <label
              :class="uom_id_threshold_label.length > 0 ? 'shift-up' : ''"
              >{{ $tc("unitofmeasurement", 2) }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                disabled
                :text="uom_id_threshold_label"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Unit"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchUnit()"
                    v-on:keydown="onSearchUnit()"
                    v-on:search="onSearchUnit()"
                    v-model="searchUnit"
                  />
                </div>
                <b-dropdown-item
                  v-for="(uom, uomIndex) in units_of_measurements"
                  :key="uomIndex"
                  href="#"
                  @click="
                    uom_id_threshold = uom.uom_id;
                    uom_id_threshold_label = uom.uom_unit;
                    searchUnit = '';
                    onSearchUnit();
                  "
                  name="uomdropdown"
                  id="uomdropdown"
                  >{{ uom.uom_unit }}</b-dropdown-item
                >
              </b-dropdown>
              <!-- <Tooltip :title="$t('rawMaterial_unitofmeasurement')" /> -->
            </div>
            <p class="error_message">
              <span v-if="submitted && uom_id_threshold_label.length == 0"
                >Please Select Unit of Measurement.</span
              >
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-3 align-self-center mb-3">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="rm_description"
                name="rm_description"
                id="rm_description"
                v-validate="'max:250'"
              />
              <label>{{ $t("description") }}</label>
            </div>
            <!-- <Tooltip :title="$t('description_tooltip')" /> -->
          </div>
          <!-- <p
            v-if="submitted && errors.has('description')"
            class="error_message"
          >{{ errors.first('description') }}</p>-->
           <p class="error_message">
              <span v-if="submitted && errors.has('rm_description')">{{
                errors.first("rm_description")
              }}</span>
            </p>
        </div>
  <template v-if="showErpColumns">
        <div class="col-lg-6 col-xl-3 align-self-center mb-3">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                v-model="report_code"
                name="report_code"
                id="report_code"
                placeholder="."
                v-validate="'regex:/^[a-zA-Z0-9 ]*$/|max:150'"
              />
              <label>{{ "Report Code" }}</label>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-3 align-self-center mb-3">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                v-model="gl_account"
                name="gl_account"
                id="gl_account"
                placeholder="."
                v-validate="'regex:/^[a-zA-Z0-9 ]*$/|max:150'"
              />
              <label>{{ "GL Account" }}</label>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-3 align-self-center mb-3">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                v-model="gl_desc"
                name="gl_desc"
                id="gl_desc"
                placeholder="."
                v-validate="'regex:/^[a-zA-Z0-9 ]*$/|max:150'"
              />
              <label>{{ "GL Description" }}</label>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>
  </template>

        <div
          class="col-xl-6 col-lg-8 col-sm-12 align-self-center align-items-center mb-4 pb-2"
        >
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <b-form-checkbox
                type="checkbox"
                class="j-checkbox"
                style="padding-bottom: 0px"
                v-model="is_inventory"
                unchecked-value="N"
                value="Y"
              >
              </b-form-checkbox>
              <label class="mb-0" style="white-space: nowrap">{{
                "Is Inventory"
              }}</label>
            </div>

            <div class="d-flex align-items-center">
              <b-form-checkbox
                type="checkbox"
                class="j-checkbox"
                style="padding-bottom: 0px"
                v-model="recco"
              >
              </b-form-checkbox>
              <label class="mb-0" style="white-space: nowrap">{{
                $t("recco")
              }}</label>
            </div>

            <div class="d-flex align-items-center">
              <b-form-checkbox
                type="checkbox"
                class="j-checkbox"
                style="padding-bottom: 0px"
                v-model="is_expiry_available"
              >
              </b-form-checkbox>
              <label class="mb-0" style="white-space: nowrap">{{
                $t("isExpiryavailable")
              }}</label>
            </div>

            <div class="d-flex align-items-center">
              <b-form-checkbox
                type="checkbox"
                class="j-checkbox"
                style="padding-bottom: 0px"
                v-model="rm_is_active"
              >
              </b-form-checkbox>
              <label class="mb-0" style="white-space: nowrap">{{
                $t("active")
              }}</label>
            </div>
          </div>
        </div>

        <div class="col-md-12 text-center mt-4">
          <!-- <button v-on:click="onFinalSubmit(true)" class="btn-blue">{{ $t('saveaddmore') }}</button> -->
          <button @click.prevent.stop="onFinalSubmit(true)" class="btn-blue">
            {{ $t("update") }}
          </button>
          <button @click.prevent.stop="onResetForm()" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="/fnb/raw-materials"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import MasterService from "@/services/MasterService";
import PosFnbService from "@/services/PosFnbService";
export default {
  components: { Multiselect },
  data() {
    return {
      raw_material_categoriesCopy: [],
      searchRawMaterial: "",
      searchUnit: "",
      units_of_measurementsCopy: [],
      submitted: false,
      errmsg: "",
      rm_name: "",
      alt_rm_name: "",
      rm_code: "",
      rmc_id: "",
      rmc_label: "",
      rm_rte: true,
      recco: false,
      is_expiry_available: false,
      validStatus: false,
      rm_description: "",
      stock_alert_quantity_threshold: "",
      uom_id_threshold: "",
      rm_is_perishable: false,
      rm_is_active: true,
      selected: null,
      report_code: "",
      erp_item_type: null,
      erp_item_type_selected: "",
      gl_account: "",
      gl_desc: "",
      is_inventory: "Y",
      uom_id_threshold_label: "Select Value",
      units_of_measurements: [],
      raw_material_categories: [],
      rm_id: "",
    };
  },
  beforeMount() {
    this.rm_id = this.$route.query.rm_id;
  },
  computed: {
    showErpColumns() {
      return this.$store.getters.SHOW_ERP_GL_FIELDS == 'Y' ? true : false;
    },
  },
  mounted() {
    this.getRawMaterialDetails();
  },
  methods: {
    onSearchRawMaterial: function () {
      if (this.searchRawMaterial && this.searchRawMaterial.length > 0) {
        this.raw_material_categories = this.raw_material_categoriesCopy.filter(
          (x) => {
            if (
              x.rmc_category
                .toLowerCase()
                .includes(this.searchRawMaterial.toLowerCase())
            ) {
              return x;
            }
          }
        );
      } else {
        this.raw_material_categories = this.raw_material_categoriesCopy;
      }
    },
    onSearchUnit: function () {
      if (this.searchUnit && this.searchUnit.length > 0) {
        this.units_of_measurements = this.units_of_measurementsCopy.filter(
          (x) => {
            if (
              x.uom_unit.toLowerCase().includes(this.searchUnit.toLowerCase())
            ) {
              return x;
            }
          }
        );
      } else {
        this.units_of_measurements = this.units_of_measurementsCopy;
      }
    },
    getunitofmeasurements: function (obj) {
      let payload = {
        tableName: "ms_unit_of_measurement",
        uom_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.units_of_measurements = data.Records;
            this.units_of_measurementsCopy = data.Records;
            this.uom_id_threshold = obj.uom_id_threshold;
            this.units_of_measurements.map((x) => {
              if (obj.uom_id_threshold == x.uom_id) {
                this.uom_id_threshold_label = x.uom_unit;
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    getRawMaterialDetails: function () {
      let payload = {
        tableName: "ms_raw_materials",
        rm_id: this.rm_id,
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            let obj = data.Records[0];
            this.rm_name = obj.rm_name;
            this.alt_rm_name = obj.alt_rm_name || null;
            this.rm_code = obj.rm_code;
            this.rmc_id = obj.rmc_id;
            this.getRawMaterialCategoryList(this.rmc_id);
            this.rm_rte = obj.rm_rte == "Y" ? true : false;
            this.recco = obj.recco == "Y" ? true : false;
            this.is_expiry_available =
              obj.is_expiry_available == "Y" ? true : false;
            this.rm_description = obj.rm_description;
            this.report_code = obj.report_code;
            this.gl_account = obj.gl_account;
            this.gl_desc = obj.gl_desc;
            this.erp_item_type = obj.erp_item_type;
            this.is_inventory = obj.is_inventory;
            this.validStatus = true;
            this.stock_alert_quantity_threshold =
              obj.stock_alert_quantity_threshold;
            this.rm_is_perishable = obj.rm_is_perishable == "Y" ? true : false;
            this.rm_is_active = obj.rm_is_active == "Y" ? true : false;
            this.getunitofmeasurements(obj);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    getRawMaterialCategoryList: function (rmc_id) {
      let payload = {
        tableName: "ms_raw_material_category",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            // this.raw_material_categories = data.Records;
            this.raw_material_categories = data.Records.filter(
              (x) => x.rmc_is_active === "Y"
            );
            this.raw_material_categoriesCopy = data.Records;
            data.Records.map((x) => {
              if (x.rmc_id == rmc_id) {
                this.rmc_label = x.rmc_category;
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    onResetForm: function () {
      this.rm_name = "";
      this.alt_rm_name = "";
      this.rm_rte = true;
      this.recco = false;
      this.rmc_id = "";
      this.rmc_label = "";
      this.validStatus = false;
      this.rm_description = "";
      this.stock_alert_quantity_threshold = "";
      this.uom_id_threshold = "";
      this.uom_id_threshold_label = "";

      this.report_code = "";
      this.gl_account = "";
      this.gl_desc = "";
      this.erp_item_type = "";
      this.erp_item_type_selected = "";
      this.is_inventory = "Y";

      this.rm_is_perishable = false;
      this.rm_is_active = true;
      this.selected = null;
    },
    onFinalSubmit() {
      this.submitted = true;
      if (this.uom_id_threshold_label == "Select Value") {
        this.errmsg = "Please Select Unit of Measurement Value.";
      } else {
        this.$validator.validate().then((valid) => {
          console.log("valid :", valid);
          if (valid) {
            let payload = {
              rm_id: this.rm_id,
              rm_code: this.rm_code,
              rm_name: this.rm_name,
              alt_rm_name: this.alt_rm_name,
              rmc_id: this.rmc_id,
              rm_rte: this.rm_rte ? "Y" : "N",
              recco: this.recco ? "Y" : "N",
              is_expiry_available: this.is_expiry_available,
              rm_description: this.rm_description,
              stock_alert_quantity_threshold:
                this.stock_alert_quantity_threshold,
              uom_id_threshold: this.uom_id_threshold,
              report_code: this.report_code,
              gl_account: this.gl_account,
              gl_desc: this.gl_desc,
              is_inventory: this.is_inventory,
              erp_item_type: this.erp_item_type,
              rm_is_perishable: this.rm_is_perishable ? "Y" : "N",
              rm_is_active: this.rm_is_active ? "Y" : "N",
            };
            PosFnbService.UpdateRawMaterial(payload)
              .then((response) => {
                const { data } = response;
                if (data && data.status) {
                  this.onResetForm();
                  this.$toasted.show(data.message);
                  this.$router.push({
                    path: "/fnb/raw-materials",
                  });
                } else {
                  this.$toasted.show(data.message);
                }
              })
              .catch(this._CatchError); //message
          }
        });
      }
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/RawMaterialsComponents/editRawMaterial.vue